<template>
  <div style="min-height: 100vh;background: #CDC7BA">
    <van-loading type="spinner" v-if="nodata"/>
    <div v-if="dominItem.templateId === 'temp3'">
      <div class="logo" style="display: flex;justify-content: space-between; align-items: center; padding-left: 10%"
           :class="[`${dominItem.templateId}`, `${dominItem.templateId}1`]">
        <span>{{ dominItem.logoName || 'Logo' }}</span>
        <span style="font-size: 18px">{{ nowDate }}</span></div>
      <div class="category" :class="`${dominItem.templateId}`">
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
      </div>
    </div>

    <div v-else>
      <div class="logo" style="display: flex;justify-content: space-between; align-items: center; padding: 10px 10%" :class="[`${dominItem.templateId}`, `${dominItem.templateId}1`]">
        <span style="font-size: 18px">{{ nowDate }}</span><span>{{ dominItem.logoName || 'Logo' }}</span></div>
      <div class="category" :class="`${dominItem.templateId}`">
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
      </div>
    </div>
    <div style="padding: 0 10%;">
      <div class="baseball-article-page">
        <!-- 文章主体部分 -->
        <div class="article-main">
          <h1 class="article-title">{{ bestInfo.articleTitle }}</h1>

          <span class="time">
          <img src="@/assets/icon/time_fill.png" alt="">
        <span style="margin-left: 20px;color: #000000">{{ bestInfo.uploadTime }}</span>
        <img src="@/assets/icon/eyess.png" style="margin-left: 20px" alt="">
        <span class="number">{{ bestInfo.articleReadNum }}</span>
      </span>

          <div class="article-meta">
            <img v-if="dominItem.templateId === 'temp1'" src="@/assets/temp1.jpg" alt="" class="author-logo"/>
            <img v-if="dominItem.templateId === 'temp2'" src="@/assets/temp2.jpg" alt="" class="author-logo"/>
            <img v-if="dominItem.templateId === 'temp3'" src="@/assets/temp3.jpg" alt="" class="author-logo"/>
            <div class="meta-info">
              <span class="author">{{ bestInfo.updateBy ||  $t('con_Editor')  }}</span>
              <span class="publish-date">{{ bestInfo.uploadTime }}</span>
            </div>
          </div>
          <img
              v-if="bestInfo.articleImage"
              :src="bestInfo.articleImage"
              class="article-img"
          />

<!--          <p class="photo-credit">{{ bestInfo.articleTitle }}</p>-->

          <div style="margin-top: 30px; text-align: center" v-for="item in videoList">
            <video ref="videoRef" :src="item.url" width="650" height="400" controls ></video>
          </div>
          <div class="detail" v-html="bestInfo.articleContent"></div>
        </div>
      </div>

      <div class="latest-posts-page">
        <h2 class="section-header">{{ $t('con_hot_con') }}</h2>
        <div class="posts-grid">
          <div
              v-for="(item, index) in latestNewsList"
              @click="toDetail(item.articleShortName)"
              :key="index"
              class="post-item"
          >
            <img  :src="item.articleImage" class="post-img" />
            <h3 class="post-title twoHde">{{ item.articleTitle }}</h3>
            <p class="post-date">{{ item.uploadTime }}</p>
          </div>
        </div>
      </div>

    </div>

    <div class="buttom">
      <div style="display: flex; flex-direction: column; width: 100%; padding: 0 10%">
        <div class="logo">{{ dominItem.logoName || 'Logo' }}</div>
        <div class="explore">
          <span v-for="item in typeList" @click="changeType(item.id)" style="cursor: pointer">{{ item.label }}</span>
        </div>
        <div class="img"  v-if="dominItem.nationId !== 'cn'">
          <img  v-for="item in iconListsmall" @click="openLink(item.link)" :src="item.url" alt="">
        </div>
      </div>
      <div class="content1">
        <span class="oneHde" @click="toDetail(item.articleShortName)"
              v-for="item in articleListlast">● {{item.articleTitle}}</span>
      </div>

    </div>
  </div>
</template>

<script>
import {format} from "date-fns";
import whileIcon from "@/components/icons/whileicon.vue"
import topIcon from "@/components/icons/small.vue";
import footers from "@/components/footContent/index.vue"
import {getContentList, getInfo, getLatestNews, getRecommend} from "@/api";
import {Base64} from "js-base64";

export default {
  name: "index",

  props: {
    dominItem: Object
  },

  components: {topIcon, whileIcon, footers},
  data() {
    return {
      bestInfo:{},
      articleListlast:[],
      latestNewsList: [],
      template: 'temp1',
      nowDate: undefined,
      current: 1,
      nodata: false,
      iconListsmall: [
        {url: require('../../../assets/icon/linkedin.png'), link: 'https://www.linkedin.cn/'},
        {url: require('../../../assets/icon/facebook.png'), link: 'https://www.facebook.com/'},
        {url: require('../../../assets/icon/flipboard.png'), link: 'https://www.flipboard.cn/'},
        {url: require('../../../assets/icon/twitter.png'), link: 'https://twitter.com/'},
        {url: require('../../../assets/icon/instagram.png'), link: 'https://www.instagram.com/'},
      ],

      typeList: [{label: this.$t('con_home'), id: 1},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_LIFESTYLE'), id: 5},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_TECHNOLOGY'), id: 7},
        {label: this.$t('con_about'), id: 8},],
    }
  },
  created() {
    this.current = Number(this.$route.query.type)
    this.nowDate = format(new Date(), this.$t('con_format'))

    this.getArticleListlast()
    this.getLatestNewsList()
    this.getPageInfo(this.$route.params.name)
  },
  methods: {
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.$router.push(`/?type=${item}`)
    },

    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    },

    // 根据文章id获取文章详情
    getPageInfo(name) {
      this.nodata = true
      getInfo({name: name, articleNationId: this.dominItem.nationId, domain: this.dominItem.domainName}).then(res => {
        let Base64 = require('js-base64').Base64;
        this.bestInfo = res.data.articleInfo
        this.bestInfo.uploadTime = format(new Date(this.bestInfo.uploadTime),  this.$t('con_format'))
        this.bestInfo.articleContent = Base64.decode(this.bestInfo.articleContent);
        this.nextChapter = res.data.nextChapter
        this.videoList = JSON.parse(this.bestInfo.remark)
        this.previousPost = res.data.previousPost
        this.recommendArticle = res.data.recommendArticle
        this.nodata = false
        this.bestInfo.articleImage = this.bestInfo.articleImage ? this.bestInfo.articleImage :
            JSON.parse(localStorage.getItem('dominItem')).defaultImg

      })
    },

    // 获取最下面文章列表
    getArticleListlast() {
      // this.nodata = true
      getContentList({articleCategoryId: 1,pageNum: 1, pageSize: 4, articleNationId: this.dominItem.nationId}).then(res => {
        this.articleListlast = res.rows
        this.nodata = false
      })
    },

    // 获取最后次更新的文章
    getLatestNewsList() {
      getRecommend({articleCategoryId: 1, pageNum: this.newsPageNum, pageSize: 8, articleNationId: this.dominItem.nationId}).then(res => {

        res.rows.map(r=>{
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })

        this.latestNewsList = res.rows

        this.newsTotal = res.total
      })
    },
  }
};
</script>

<style scoped lang="scss">
.baseball-article-page {
  display: flex;
  gap: 30px;
  padding: 20px;

  .article-main {
    flex: 1;

    .article-title {
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .article-meta {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .author-logo {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
      }

      .meta-info {
        .author {
          font-weight: bold;
          display: block;
        }

        .publish-date {
          font-size: 14px;
          color: #000;
        }
      }
    }

    .article-img {
      width: 80%;
      object-fit: cover;
      margin-left: 10%;
    }

    .photo-credit {
      font-size: 12px;
      color: #999;
      margin-bottom: 20px;
    }

    .article-content {
      line-height: 1.6;
    }
  }

  .sidebar {
    width: 300px;

    .sidebar-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 15px;
      padding-bottom: 5px;
      border-bottom: 2px solid #000;
    }

    .latest-post {
      .post-thumbnail {
        width: 100%;
        height: auto;
        margin-bottom: 10px;
      }

      .post-title {
        font-size: 16px;
        margin-bottom: 5px;
      }

      .post-date {
        font-size: 14px;
        color: #666;
      }
    }
  }
}
.logo {
  //width: 100%;
  //padding: 10px 10%;
  padding: 10px 0;
  background: #141414;
  box-sizing: border-box;
  font-size: 40px;
  color: #E0DAC8;
  font-weight: bold;
  text-align: left;
  border-bottom: 1px solid #fff ;
}

.logo-temp1 {
  text-align: center;
}

.logo-temp2 {
  text-align: left;
}

.category {
  width: 100%;
  padding: 0 10%;
  min-height: 50px;
  background: #FFFFFF;
  margin-bottom: 30px;
  color: #141414;
  //border-top: 2px solid var(--themeColor);
  //border-bottom: 2px solid var(--themeColor);
  line-height: 48px;

  span {
    font-weight: 700;
    font-size: 14px;
    display: inline-block;
    padding: 0 20px;
    cursor: pointer;
    position: relative;
  }

  span:hover {
    //border-bottom: 3px solid red;
    color: #000;
    transition: all .5s ease;
  }

  .choose {
    //border-bottom: 3px solid red;
    transition: all .1s ease;
    color:#000;
  }
}

.buttom {
  border-top: 5px solid #141414;
  background: #141414;
  display: flex;
  align-items: center;
  justify-content: center;

  .logo{
    border: none;
    text-align: center;
  }

  display: flex;

  .explore {
    margin: 10px 0 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    span {
      margin-right: 10px;
      font-size: 15px;
      width: 200px;
      display: inline-block;
      color: #E0DAC8;
      text-align: center;
    }
  }
}

.about {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
  font-size: 17px;
  text-transform: uppercase;
  display: flex;
  justify-content: end;
  //justify-content: space-between;
  padding-right: 20px;
  color: #ffffff;
  background: #092647;
  align-items: center;

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  img:nth-child(4) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(6) {
    width: 30px;
    height: 30px;
  }
}


.content {
  padding: 0 10% 20px;
  display: flex;
  flex-wrap: wrap;
  span{
    display: inline-block;
    margin-bottom: 10px;
    width: 50%;
  }
}

.small-title {
  font-size: 13px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin-left: 10px;
}

.small {
  font-size: 12px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin-left: 10px;
  -webkit-line-clamp: 3;
}
.img {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 30px;
  margin-bottom: 30px;
  img{
    width: 30px;
    height: 30px;
  }

  img:nth-child(3) {
    width: 40px;
    height: 40px;
  } img:nth-child(4) {
      width: 40px;
      height: 40px;
    }
  img:nth-child(5) {
    width: 40px;
    height: 40px;
  }
}
.temp1{
  padding-left: 10%;
}
.temp3{
  padding-right: 10%;
}
.time {
  color: rgba(0, 0, 0, .44);
  margin: 10px 0 20px;
  white-space: nowrap;
  line-height: 26px;
  font-weight: 400;
  font-size: 18px;
  align-items: center;
  display: flex;

  span:last-child {
    font-weight: 700;
    color: #4d4d4d;
    margin-left: 10px;
  }

  img {
    height: 20px;
  }
}

.content1 {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  span{
    display: inline-block;
    margin-bottom: 10px;
    color: #ffffff;
    font-size: 16px;
    width: 600px;
  }
}

.latest-posts-page {
  padding: 20px;

  .section-header {
    background-color: #000;
    color: #fff;
    padding: 10px;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .posts-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;

    .post-item {

      .post-img {
        width: 100%;
        height: 150px;
        object-fit: cover;
        margin-bottom: 10px;
      }

      .post-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 5px;
      }

      .post-date {
        font-size: 14px;
        color: #333;
      }
    }
  }
}
</style>